import { CurrencyCode } from 'helpers/currency';
import { LocalStorage } from 'helpers/localStorage';

export enum ETimeframe {
  Monthly = 'monthly',
  Weekly = 'weekly',
  Daily = 'daily',
}

const SELECTED_METHOD_KEY = 'selected-withdraw-method-id';

export const LocalStorageWithdrawPaymentMethod = new LocalStorage<
  string | null,
  null
>(SELECTED_METHOD_KEY, null);

export const TIMEFRAME_LIMITS: Record<string, Record<ETimeframe, number>> = {
  [CurrencyCode.EUR]: {
    [ETimeframe.Daily]: 3000,
    [ETimeframe.Weekly]: 7500,
    [ETimeframe.Monthly]: 15_000,
  },
  [CurrencyCode.AUD]: {
    [ETimeframe.Daily]: 3000,
    [ETimeframe.Weekly]: 7500,
    [ETimeframe.Monthly]: 15_000,
  },
  [CurrencyCode.CAD]: {
    [ETimeframe.Daily]: 3000,
    [ETimeframe.Weekly]: 7500,
    [ETimeframe.Monthly]: 15_000,
  },
  [CurrencyCode.NZD]: {
    [ETimeframe.Daily]: 3000,
    [ETimeframe.Weekly]: 7500,
    [ETimeframe.Monthly]: 15_000,
  },
  [CurrencyCode.USD]: {
    [ETimeframe.Daily]: 3000,
    [ETimeframe.Weekly]: 7500,
    [ETimeframe.Monthly]: 15_000,
  },
  [CurrencyCode.NOK]: {
    [ETimeframe.Daily]: 30_000,
    [ETimeframe.Weekly]: 75_000,
    [ETimeframe.Monthly]: 150_000,
  },
  [CurrencyCode.USDT]: {
    [ETimeframe.Daily]: 3000,
    [ETimeframe.Weekly]: 7500,
    [ETimeframe.Monthly]: 15_000,
  },
  [CurrencyCode.DOG]: {
    [ETimeframe.Daily]: 16_500,
    [ETimeframe.Weekly]: 40_000,
    [ETimeframe.Monthly]: 80_000,
  },
  [CurrencyCode.BTC]: {
    [ETimeframe.Daily]: 45,
    [ETimeframe.Weekly]: 110,
    [ETimeframe.Monthly]: 220,
  },
  [CurrencyCode.BCH]: {
    [ETimeframe.Daily]: 5500,
    [ETimeframe.Weekly]: 14_000,
    [ETimeframe.Monthly]: 28_000,
  },
  [CurrencyCode.ETH]: {
    [ETimeframe.Daily]: 910,
    [ETimeframe.Weekly]: 2300,
    [ETimeframe.Monthly]: 4600,
  },
  [CurrencyCode.LTC]: {
    [ETimeframe.Daily]: 33_000,
    [ETimeframe.Weekly]: 83_000,
    [ETimeframe.Monthly]: 166_000,
  },
};
